const containerCallout = document.querySelector('.js-callout')

if(containerCallout){
  const swatches = containerCallout.querySelectorAll('.js-swatch');
  const blocks = containerCallout.querySelectorAll('.js-block');

  const clearAllSwatches = () => {
    swatches.forEach(swatch => {
      swatch.classList.remove('active');
    })
  }

  const clearAllBlocks = () => {
    blocks.forEach(block => {
      block.classList.remove('active');
    })
  }

  swatches.forEach(swatch => {
    swatch.addEventListener('click', () => {
      clearAllSwatches();
      clearAllBlocks();

      swatch.classList.add('active');

      const no = swatch.getAttribute('data-no')
      const activeBlock = containerCallout.querySelector(`.js-block[data-no="${no}"]`)
      activeBlock.classList.add('active')
    })
  })
}

// Ingredients Accordion Toggle
const seeAllBtn = document.querySelector('.js-callout-see-all-ingredients');
const accordion = document.getElementById('callout-ingredients-accordion');

if (seeAllBtn && accordion) {
  const originalText = seeAllBtn.textContent.trim();
    seeAllBtn.addEventListener('click', () => {
        const isOpen = accordion.classList.toggle('is-open');
            accordion.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
                seeAllBtn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
                    seeAllBtn.textContent = isOpen ? 'HIDE INGREDIENTS' : originalText;
                      });
                      }